<template>
  <div class="wrap-box-prices">
    <div v-if="loading" role="status">正在載入紙箱規格與費用…</div>
    <div v-else-if="error" role="alert">
      {{ error }}
      <button type="button" class="retry-button" @click="$emit('retry')">重新載入</button>
    </div>
    <details v-else-if="boxes.length">
      <summary>查看可用紙箱規格與費用</summary>
      <div class="table-scroll">
        <table>
          <thead>
            <tr>
              <th scope="col">紙箱</th>
              <th scope="col">型號</th>
              <th scope="col">長 × 寬 × 高（cm）</th>
              <th scope="col">費用／件</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="box in boxes" :key="box.boxStyle">
              <td>{{ box.serviceBrief }}</td>
              <td>{{ box.boxStyle }}</td>
              <td>{{ box.boxLength / 10 }} × {{ box.boxWidth / 10 }} × {{ box.boxHeight / 10 }}</td>
              <td>NT${{ box.surchargeFee }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </details>
  </div>
</template>

<script>
export default {
  props: {
    boxes: { type: Array, default: () => [] },
    loading: Boolean,
    error: String,
  },
}
</script>

<style scoped>
.wrap-box-prices {
  margin: 8px 0;
  font-size: 13px;
  line-height: 1.6;
}
summary, .retry-button {
  cursor: pointer;
  color: #1976d2;
}
.retry-button {
  margin-left: 8px;
  text-decoration: underline;
}
.table-scroll {
  overflow-x: auto;
  margin-top: 8px;
}
table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
}
th, td {
  padding: 6px 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
</style>
